import React, { useEffect, useState, useContext } from "react";
import "./transactions.css";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { GoCheckCircle } from "react-icons/go";
import { TbXboxX } from "react-icons/tb";
import Dropdown from "react-bootstrap/Dropdown";
import { LanguageContext } from "../../Components/LanguageContext";
import translations from "./translation.json";
import { axiosInstance } from "../../axiosInstance";
import { Link } from "react-router-dom";
import dayjs from "dayjs";
import { useLocation } from "react-router-dom";

export function Transactions() {
  const [selectedDate, setSelectedDate] = useState("");
  const [recentFirst, setRecentFirst] = useState(false);

  const { language } = useContext(LanguageContext);
  const [activeTab, setActiveTab] = useState("withdrawn");
  const [transaction, setTransaction] = useState([]);
  const [withdraw, setWithDraw] = useState([]);
  const [customersRequest, setCustomersRequest] = useState([]);

  const location = useLocation();

  // useEffect(() => {
  //   fetchTransactions();
  //   fetchWithdrawals();
  //   fetchCustomersRequest();
  // }, []);

  useEffect(() => {
    if (location.state?.tab === "customers") {
      setActiveTab("customers");
    }
    fetchTransactions();
    fetchWithdrawals();
    fetchCustomersRequest();
  }, []);

  const fetchTransactions = async () => {
    try {
      const response = await axiosInstance.get("transaction");
      setTransaction(response.data.data);
    } catch (error) {
      console.log("Error while fetching transactions", error);
    }
  };

  const fetchWithdrawals = async () => {
    try {
      const response = await axiosInstance.get("withdraw");
      setWithDraw(response.data.data);
    } catch (error) {
      console.log("Error while fetching withdrawals", error);
    }
  };

  const fetchCustomersRequest = async () => {
    try {
      const response = await axiosInstance.get("agent_requests");
      const apiData = response.data.data;

      // Transform API data to match column keys
      const formatted = apiData.map((item) => ({
        FullName: item.user_name || "--",
        Mobile: item.mobile_number || "--",
        SubmittedOn: dayjs(item.created_at).format("DD/MM/YYYY"),
        requested_profile_id: item.requested_profile_id || "--",
      }));

      setCustomersRequest(formatted);
    } catch (error) {
      console.log("Error while fetching customers request", error);
    }
  };

  const withdrawnColumns = [
    {
      id: "Date",
      label: translations[language].date,
      minWidth: 150,
      align: "center",
    },
    {
      id: "Withdrawnpoints",
      label: translations[language].withdrawn_points,
      minWidth: 100,
      align: "center",
    },
    {
      id: "RemainingPoints",
      label: translations[language].remaining_points,
      minWidth: 170,
      align: "center",
    },
  ];

  function handleWithdrawn() {
    const filteredData = selectedDate
      ? withdraw.filter(
          (drawn) => drawn.updated_at.slice(0, 10) === selectedDate
        )
      : withdraw;
    //  for recentfirst simply reverse the array of data getting from api
    const displayData = recentFirst
      ? [...filteredData].reverse()
      : filteredData;

    const withdrawnRows = displayData.map((drawn) => ({
      Date: drawn.updated_at.slice(0, 10) || "--",
      Withdrawnpoints: drawn.amount || "0",
      RemainingPoints: drawn.remaining_points || "0",
    }));

    return (
      <Paper sx={{ width: "100%", overflow: "hidden" }}>
        <TableContainer className="tableContainer">
          <Table stickyHeader aria-label="withdrawn table">
            <TableHead>
              <TableRow>
                {withdrawnColumns.map((column) => (
                  <TableCell
                    className="trasactiontableHeader"
                    key={column.id}
                    align={column.align}
                    style={{ minWidth: column.minWidth }}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {withdrawnRows.length > 0 ? (
                withdrawnRows.map((row, index) => (
                  <TableRow hover tabIndex={-1} key={index}>
                    {withdrawnColumns.map((column) => (
                      <TableCell
                        key={column.id}
                        align={column.align}
                        className="trasactiontableBody"
                        sx={{
                          color:
                            column.id === "Withdrawnpoints"
                              ? "#AC3047"
                              : "#716466",
                        }}
                      >
                        {row[column.id]}
                      </TableCell>
                    ))}
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={withdrawnColumns.length} align="center">
                    Record not found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    );
  }

  const earnedColumns = [
    {
      id: "category",
      label: translations[language].category,
      minWidth: 150,
      align: "center",
    },
    {
      id: "Date",
      label: translations[language].date,
      minWidth: 150,
      align: "center",
    },
    {
      id: "Earnedpoints",
      label: translations[language].earned_points,
      minWidth: 100,
      align: "center",
    },
    {
      id: "TotalPoints",
      label: translations[language].total_points,
      minWidth: 170,
      align: "center",
    },
  ];

  function handleEarnedPoints() {
    const filteredData = selectedDate
      ? transaction.filter(
          (drawn) => drawn.created_at.slice(0, 10) === selectedDate
        )
      : transaction;

    //  for recentfirst simply reverse the array of data getting from api
    const displayData = recentFirst
      ? [...filteredData].reverse()
      : filteredData;

    const earnedRows = displayData.map((earned) => ({
      category: earned.category || "--",
      Date: earned.created_at.slice(0, 10) || "--",
      Earnedpoints: earned.points || "--",
      TotalPoints: earned.total_points || "--",
    }));

    return (
      <Paper sx={{ width: "100%", overflow: "hidden" }}>
        <TableContainer className="tableContainer">
          <Table stickyHeader aria-label="earned table">
            <TableHead>
              <TableRow>
                {earnedColumns.map((column) => (
                  <TableCell
                    className="trasactiontableHeader"
                    key={column.id}
                    align={column.align}
                    style={{ minWidth: column.minWidth }}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {earnedRows.length > 0 ? (
                earnedRows.map((row, index) => (
                  <TableRow hover tabIndex={-1} key={index}>
                    {earnedColumns.map((column) => (
                      <TableCell
                        key={column.id}
                        align={column.align}
                        className="trasactiontableBody"
                        sx={{
                          color:
                            column.id === "Earnedpoints"
                              ? "#007D1F"
                              : "#716466",
                        }}
                      >
                        {row[column.id]}
                      </TableCell>
                    ))}
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={earnedColumns.length} align="center">
                    Record not found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    );
  }

  const customerColumns = [
    {
      id: "FullName",
      label: translations[language].full_name,
      minWidth: 170,
      align: "center",
    },
    {
      id: "Mobile",
      label: translations[language].mobile,
      minWidth: 100,
      align: "center",
    },
    {
      id: "SubmittedOn",
      label: translations[language].submitted_on,
      minWidth: 170,
      align: "center",
    },
    {
      id: "Actions",
      label: translations[language].actions,
      minWidth: 170,
      align: "center",
    },
  ];

  const customerRows = [
    {
      FullName: "Suresh Kumar",
      Mobile: 9876543210,
      NotifyWhatsapp: "Yes",
      SubmittedOn: "02/04/2025",
    },
    {
      FullName: "Suresh Kumar",
      Mobile: 9876543210,
      NotifyWhatsapp: "Yes",
      SubmittedOn: "02/04/2025",
    },
  ];

  const handleCustomers = () => {
    return (
      // <Paper sx={{ width: "100%", overflow: "hidden" }}>
      //   <TableContainer className="tableContainer">
      //     <Table stickyHeader aria-label="customers table">
      //       <TableHead>
      //         <TableRow>
      //           {customerColumns.map((column) => (
      //             <TableCell
      //               className="trasactiontableHeader"
      //               key={column.id}
      //               align={column.align}
      //               style={{ minWidth: column.minWidth }}
      //             >
      //               {column.label}
      //             </TableCell>
      //           ))}
      //         </TableRow>
      //       </TableHead>
      //       <TableBody>
      //         {customerRows.map((row, index) => (
      //           <TableRow hover tabIndex={-1} key={index}>
      //             {customerColumns.map((column) => (
      //               <TableCell
      //                 key={column.id}
      //                 align={column.align}
      //                 className="trasactiontableBody"
      //                 sx={{ color: "#716466" }}
      //               >
      //                 {column.id === "Actions" ? (
      //                   <div>
      //                     <span>
      //                       <GoCheckCircle className="text-danger fs-5" />
      //                     </span>
      //                     &nbsp;&nbsp;
      //                     <span>
      //                       <TbXboxX className="text-success fs-5" />
      //                     </span>
      //                   </div>
      //                 ) : (
      //                   row[column.id]
      //                 )}
      //               </TableCell>
      //             ))}
      //           </TableRow>
      //         ))}
      //       </TableBody>
      //     </Table>
      //   </TableContainer>
      // </Paper>
      <Paper sx={{ width: "100%", overflow: "hidden" }}>
        <TableContainer className="tableContainer">
          <Table stickyHeader aria-label="customers table">
            <TableHead>
              <TableRow>
                {customerColumns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{ minWidth: column.minWidth }}
                    className="trasactiontableHeader"
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {customersRequest.map((row, index) => (
                <TableRow hover tabIndex={-1} key={index}>
                  {customerColumns.map((column) => {
                    const value = row[column.id];

                    if (column.id === "Actions") {
                      return (
                        <TableCell
                          key={column.id}
                          align="center"
                          className="trasactiontableBody"
                        >
                          {/* {row.requested_profile_id ? (
                            <Link
                              to={`/request-profile-view/${row.requested_profile_id}`}
                              className="text-primary"
                            >
                              View Profile
                            </Link>
                          ) : (
                            <div>
                              <span>
                                <GoCheckCircle className="text-danger fs-5" />
                              </span>
                              &nbsp;&nbsp;
                              <span>
                                <TbXboxX className="text-success fs-5" />
                              </span>
                            </div>
                          )} */}
                          {row.requested_profile_id &&
                          row.requested_profile_id !== "--" ? (
                            <Link
                              to={`/request-profile-view/${row.requested_profile_id}`}
                              className="text-primary"
                            >
                              View Profile
                            </Link>
                          ) : (
                            <span className="text-muted">
                              <span>No Request Profile Found</span>
                            </span> // 👈 optional fallback
                          )}
                        </TableCell>
                      );
                    }

                    return (
                      <TableCell
                        key={column.id}
                        align={column.align}
                        className="trasactiontableBody"
                        sx={{ color: "#716466" }}
                      >
                        {value}
                      </TableCell>
                    );
                  })}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    );
  };

  return (
    <div className="trasactionContainer">
      <div className="container">
        <div className="trasactionGrid">
          <div className="trasactionMenu">
            <span
              onClick={() => setActiveTab("withdrawn")}
              className={activeTab === "withdrawn" ? "active-tab" : ""}
            >
              {translations[language].withdrawn_points}
            </span>
            <span
              onClick={() => setActiveTab("earned")}
              className={activeTab === "earned" ? "active-tab" : ""}
            >
              {translations[language].earned_points}
            </span>
            <span
              onClick={() => setActiveTab("customers")}
              className={activeTab === "customers" ? "active-tab" : ""}
            >
              {translations[language].customers_request}
            </span>
          </div>

          <div>
            <Dropdown className="filterDropdown">
              <Dropdown.Toggle id="dropdown-basic">Filter</Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item onClick={() => setRecentFirst(!recentFirst)}>
                  {recentFirst ? "Oldest First" : "Recent First"}
                </Dropdown.Item>

                <Dropdown.Item
                  as="div"
                  className="px-3 py-2"
                  onClick={(e) => e.stopPropagation()}
                >
                  <label className="d-block mb-1">Custom Date:</label>
                  <input
                    type="date"
                    value={selectedDate}
                    onChange={(e) => setSelectedDate(e.target.value)}
                    className="form-control"
                  />
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
        {/* showing content here for selected tabs */}
        <div>
          {activeTab === "withdrawn"
            ? handleWithdrawn()
            : activeTab === "earned"
            ? handleEarnedPoints()
            : handleCustomers()}
        </div>
      </div>
    </div>
  );
}
